import {alias, createModelSchema, custom, serialize, deserialize, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";

import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";

export class WorldRegionWonderModel extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(WorldRegionWonderModel, v) : SKIP;
            },
            (v) => {
                return deserialize(WorldRegionWonderModel, v);
            }
        );
    }

    constructor() {
        super();

        this._platform = null;
        this._item = null;
        this._currency = null;

    }

    get platform() {
        return this._platform;
    }

    set platform(value) {
        this._platform = value;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency= value;
    }

    valid() {

        if (!this.currency || !CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (this.platform && (!this.platform.valid() || this.platform.any())) {
            return false;
        }

         if (this.item && (!this.item.valid() || this.item.any())) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new WorldRegionWonderModel());
        } else if (target instanceof WorldRegionWonderModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(WorldRegionWonderModel, {
    _platform: alias("platform", ItemKey.schema()),
    _item: alias("item", ItemKey.schema()),
    _currency: alias("currency", CurrencyKindModel.schema())
});